import React, {Component} from 'react';
import {connect} from 'react-redux'
import {withStyles} from 'material-ui/styles'
import { CircularProgress } from 'material-ui/Progress';
import { beginTask, endTask } from 'redux-nprogress';
import flow from 'lodash/flow'
import logo from '../img/logo.svg'

class PageLoading extends Component {

    componentDidMount() {
        this.props.onLoadingStarted()
    }

    componentWillUnmount() {
        this.props.onLoadingEnded()
    }

    render() {
        const {classes, showSpinner, error, timedOut, pastDelay} = this.props;
        if (error) {
            return null;
            //return <div>Error!</div>;
        } else if (timedOut) {
            return null;
        } else if (pastDelay) {
            return null;
        } else {
            if(!showSpinner) return null;
            return <div className={classes.container}>
                <img className={classes.logo} src={logo} alt="Evoenergy Logo" />
                <CircularProgress thickness={1} color="accent" />
            </div>;
        }
    }
}


const mapDispatchToProps = (dispatch) => {
    return {
        onLoadingStarted: () => {
            dispatch( beginTask() );
        },
        onLoadingEnded: () => {
            dispatch( endTask() );
        }
    }
}

const styles = theme => ({
    container: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column'
    },
    logo: {
        width: 250,
        marginBottom: theme.spacing.normal
    }
})

export default flow([
    connect(null, mapDispatchToProps),
    withStyles(styles)
])(PageLoading)


// WEBPACK FOOTER //
// ./src/components/PageLoading.js